import fees from './fees';
export default {
    list: fees,
};
